(function ($) {
	class W4D_Meter {
		constructor() {
			if (!window.location.pathname.includes('/kosarica/')) return;

			this.initSelectors();
			// Check if browser supports CSS anchor positioning
			this.supportsAnchorPositioning = CSS.supports('anchor-name', '--test');

			// Detect Firefox
			this.isFirefox = /Firefox/.test(navigator.userAgent);

			const currentAmount = this.parsePrice(this.currentPrice);
			this.animateMeterValue(0, currentAmount);
			this.initMeter(this.calculatePercentage(this.currentPrice, this.freeDeliveryAmount));
			this.bindEvents();
		}

		initSelectors() {
			this.$meterContainer = $('[data-js-meter-container]');
			this.$meterElement = $('[data-js-meter-element]');
			this.$meterText = $('[data-js-meter-text]');
			this.currentPrice = parseFloat(this.$meterContainer.data('current-price'));
			this.freeDeliveryAmount = parseFloat(this.$meterContainer.data('free-delivery'));
		}

		bindEvents() {
			let resizeTimeout;
			$(window).on('resize', () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => {
					this.updateTextPosition();
				}, 150);
			});
		}

		applyFirefoxTransform() {
			if (!this.isFirefox) return;

			if (this.$meterContainer.hasClass('meter--completed')) {
				this.$meterText.css('transform', '');
				return;
			}

			const meterElement = this.$meterElement[0];
			const meterWidth = meterElement.offsetWidth;
			const progressWidth = (parseFloat(meterElement.value) / parseFloat(meterElement.max)) * meterWidth;

			// On initial load (when text-inside is NOT present)
			if (!this.$meterContainer.hasClass('text-inside')) {
				const transform = `translateX(calc(-${meterWidth}px + ${progressWidth}px))`;
				this.$meterText.css('transform', transform);
			} else {
				// When text-inside class is present
				const textWidth = this.$meterText.outerWidth();
				const transform = `translateX(calc(-${meterWidth}px + ${progressWidth}px - ${textWidth}px))`;
				this.$meterText.css('transform', transform);
			}
		}

		updateTextPosition() {
			// Only apply to meter--1 variant
			if (!this.$meterContainer.hasClass('meter--1')) return;

			const meterElement = this.$meterElement[0];
			const textWidth = this.$meterText.outerWidth();
			const containerWidth = this.$meterContainer.width();

			// Calculate current progress bar width
			const progressWidth = (parseFloat(meterElement.value) / parseFloat(meterElement.max)) * meterElement.offsetWidth;

			// Calculate remaining (unfilled) width
			const remainingWidth = containerWidth - progressWidth;

			// Buffer for padding
			const buffer = 20;

			// Check if text fits in the REMAINING area (outside the progress bar)
			// If it doesn't fit outside, move it inside
			if (textWidth + buffer > remainingWidth) {
				this.$meterContainer.addClass('text-inside');
			} else {
				this.$meterContainer.removeClass('text-inside');
			}

			// Apply Firefox-specific transform after class changes
			this.applyFirefoxTransform();
		}

		updateMeterAfterCartChange(currentPrice) {
			if (currentPrice !== undefined) {
				this.$meterContainer.data('current-price', currentPrice).attr('data-current-price', currentPrice);
				this.currentPrice = currentPrice;
			} else {
				this.currentPrice = this.$meterContainer.data('current-price');
			}

			const freeDeliveryAmount = this.$meterContainer.data('free-delivery');
			const percentage = this.calculatePercentage(this.currentPrice, freeDeliveryAmount);

			const currentAmount = this.parsePrice(this.currentPrice);
			const freeDeliveryValue = this.parsePrice(freeDeliveryAmount);
			const remainingAmount = (freeDeliveryValue - currentAmount).toFixed(2);

			const $amountBdi = this.$meterText.find('.woocommerce-Price-amount bdi');

			if (percentage >= 100) {
				this.$meterText.html('<strong>Ostvarili ste besplatnu dostavu</strong>');
			} else if ($amountBdi.length) {
				$amountBdi.contents().first().replaceWith(remainingAmount.replace('.', ','));
			} else {
				this.$meterText.html(
					`Još samo <strong><span class="woocommerce-Price-amount amount"><bdi>${remainingAmount.replace('.', ',')}&nbsp;<span class="woocommerce-Price-currencySymbol">${w4d_frontend_ajax.currency_symbol}</span></bdi></span></strong> do besplatne dostave`
				);
			}

			const oldValue = parseFloat(this.$meterElement.val());
			this.animateMeterValue(oldValue, currentAmount);
			this.initMeter(percentage);
		}

		animateMeterValue(startValue, endValue, duration = 300) {
			if (this.animationFrame) {
				cancelAnimationFrame(this.animationFrame);
			}

			const startTime = performance.now();
			const updateMeter = (currentTime) => {
				const elapsedTime = currentTime - startTime;
				const progress = Math.min(elapsedTime / duration, 1);
				const easeProgress = 1 - (1 - progress) * (1 - progress);
				const currentValue = startValue + (endValue - startValue) * easeProgress;

				this.$meterElement.val(currentValue);

				// Update text position during animation
				this.updateTextPosition();

				if (progress < 1) {
					this.animationFrame = requestAnimationFrame(updateMeter);
				}
			};
			this.animationFrame = requestAnimationFrame(updateMeter);
		}

		calculatePercentage(currentPrice, freeDeliveryAmount) {
			const currentAmount = this.parsePrice(currentPrice);
			const targetAmount = this.parsePrice(freeDeliveryAmount);

			const percentage = (currentAmount / targetAmount) * 100;
			return Math.min(percentage, 100).toFixed(2);
		}

		parsePrice(price) {
			price = typeof price === 'string' ? price : String(price);
			return parseFloat(price.replace(',', '.'));
		}

		initMeter(percentage) {
			const progressPercent = Math.min(percentage, 100);

			progressPercent >= 100
				? this.$meterContainer.addClass('meter--completed')
				: this.$meterContainer.removeClass('meter--completed');

			// Check if text should be inside or outside
			this.updateTextPosition();
		}
	}

	$(document).ready(() => {
		window.W4D_Meter = new W4D_Meter();
	});
})(jQuery);
